import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dropdown,
  Flex,
  Loading,
  Popconfirm,
  Triangle,
  Typography,
} from 'shared/_ui';
import { DropdownHandles } from 'shared/_ui';
import styles from './styles.module.scss';
import { useFetchXrayServers } from './api/fetchAvailableServers';
import { useFetchUserInfo } from 'entities/Connection';
import { getTariffType } from 'entities/Tariff';
import { notify } from 'shared';

type CountrySelectProps = {
  id: number;
  country?: string;
  isNewConnectionLoading?: boolean;
  disabled?: boolean;
  onConfirm: (connectionId: number, countryId: number) => void;
};

const XrayCountrySelect: React.FC<CountrySelectProps> = ({
  id,
  country,
  onConfirm,
  isNewConnectionLoading,
  disabled = false,
}) => {
  const dropdownRef = React.useRef<DropdownHandles>(null);

  const { data: countries, isLoading } = useFetchXrayServers(null);
  const { t } = useTranslation();

  const selectedCountry = country
    ? t(`country.name.${country.toLowerCase()}`, { defaultValue: country })
    : null;

  const { data: userInfo } = useFetchUserInfo(null);
  const tariff = userInfo ? getTariffType(userInfo?.tariff) : 'free';

  if (isLoading || isNewConnectionLoading) {
    return <Loading size="small" variant="squares" />;
  }


  return (
    <Dropdown
      ref={dropdownRef}
      contentClassName={styles.content}
      className={styles.dropdown}
      position="bottom-right"
      disabled={disabled}
      content={
        countries?.length ? (
          <Flex direction="column" className={styles.select}>
            {countries?.map((country) => (
              <Popconfirm
                key={country.id}
                className={styles.hint}
                title={t('xray.countryChangeHint')}
                onConfirm={() => {
                if(tariff === "free") {
                  notify.error(t("banner.noXrayPopup"));
                  return;
                }
                onConfirm(id, country.id)}}
              >
                <Button className={styles.country} type="text">
                  <Typography.Text size={5}>
                    {t(`country.name.${country.country.toLowerCase()}`, {
                      defaultValue: country.country,
                    })}
                  </Typography.Text>
                </Button>
              </Popconfirm>
            ))}
          </Flex>
        ) : (
          <div className={styles.empty}>
            <Typography.Text size={4}>{t('shared.text.empty')}</Typography.Text>
          </div>
        )
      }
    >
      <Button
        className={styles.control}
        type="text"
        suffix={<Triangle className={styles.triangle} />}
      >
        <Typography.Text size={5}>
          {selectedCountry ?? t('country.name.empty')}
        </Typography.Text>
      </Button>
    </Dropdown>
  );
};

export { XrayCountrySelect };
